import React, { useState } from 'react'

import { ConfirmationModal, Toast } from 'components'

// Utils and Services
import { updateLeadContactStatus } from 'services/lead-contact'
import useContactInfo from 'hooks/use-contact-info'
import { FETCHING_STATUS } from 'utils/constants'
import { useTranslation } from 'react-i18next'

type Props = {
  contactId: string
  leadId: string
  onAction: (success?: boolean) => void
}

const ReactivateConfirmationModal: React.FC<Props> = ({ contactId, leadId, onAction }) => {
  const { invalidateQuery } = useContactInfo({
    leadId,
    queryOptions: {
      enabled: false,
    },
  })
  const { t } = useTranslation()

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleReactivateContact = async () => {
    setIsSubmitting(true)

    const response = await updateLeadContactStatus({ contact_id: contactId, is_active: true })

    setIsSubmitting(false)

    if (response.status === FETCHING_STATUS.fail) {
      Toast.toastMessage({ actionKey: 'reactivate', subject: 'lead_contact', variant: 'error' })
      return
    }

    Toast.toastMessage({ actionKey: 'reactivate', subject: 'lead_contact', variant: 'success' })
    invalidateQuery()
    onAction(true)
  }

  return (
    <ConfirmationModal
      isSubmitting={isSubmitting}
      cancel={() => onAction(false)}
      submit={handleReactivateContact}
      variant="reactivate"
      name={t('contact_lbl').toLowerCase()}
    />
  )
}

export default ReactivateConfirmationModal
